import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SERVICES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/src/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/${COMMON_QUERY_PARAMS.SERVICE}-attachments/${COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID}`;

export interface DeleteFileAttachmentCommandPayload {
  fileId: string;
  fileAttachmentId: string;
  service: SERVICES;
}

const deleteFileAttachmentCommand = async ({
  fileId,
  fileAttachmentId,
  service,
}: DeleteFileAttachmentCommandPayload): Promise<BaseBackResponse> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId)
      .replace(COMMON_QUERY_PARAMS.SERVICE, service)
      .replace(COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID, fileAttachmentId);

    const response = await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.DELETE,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default deleteFileAttachmentCommand;
